import { isAccessible } from './is-accessible';
export var getRobots = function (item) {
    if (item === void 0) { item = {}; }
    return isAccessible(item) ? 'index' : 'noindex';
};
